import { colors, spacing, typography } from '../../../styles/theme';

const font = typography.fontFamily.primary;

/** Fondo de `/app`: debajo del header y paneles (zIndex 0), no captura clicks fuera del card. */
export const mapUnavailableBackdropSx = {
  position: 'absolute',
  inset: 0,
  zIndex: 0,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  px: 2,
  bgcolor: colors.backgroundDark,
  pointerEvents: 'none',
  '& > *': { pointerEvents: 'auto' },
};

/** Lugar del mapa / plano (Showroom, mapa del share). */
export const mapUnavailableStageSx = {
  position: 'absolute',
  inset: 0,
  display: 'flex',
  // Mobile: arriba, para que el bottom sheet de la lista no lo tape.
  alignItems: { xs: 'flex-start', md: 'center' },
  justifyContent: 'center',
  p: 2,
  bgcolor: colors.backgroundDark,
  overflowY: 'auto',
  boxSizing: 'border-box',
};

export const mapUnavailableCardSx = (compact) => ({
  width: '100%',
  maxWidth: compact ? 320 : 440,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  textAlign: 'center',
  gap: compact ? 0.75 : 1.25,
  p: compact ? 2 : 3,
  borderRadius: spacing.borderRadius.lg,
  border: `1px solid ${colors.border}`,
  bgcolor: colors.backgroundSurface,
  boxSizing: 'border-box',
});

export const mapUnavailableIconBoxSx = {
  width: 40,
  height: 40,
  borderRadius: spacing.borderRadius.md,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  bgcolor: `${colors.primary}26`,
};

export const mapUnavailableIconSx = { color: colors.primary, fontSize: 22 };

export const mapUnavailableTitleSx = (compact) => ({
  fontFamily: font,
  fontWeight: typography.fontWeight.semibold,
  fontSize: compact ? '14px' : '16px',
  lineHeight: compact ? '18px' : '22px',
  color: colors.textPanelTitle,
});

export const mapUnavailableTextSx = {
  fontFamily: font,
  fontSize: '13px',
  lineHeight: '18px',
  color: colors.textSecondary,
};

export const mapUnavailableHintSx = {
  ...mapUnavailableTextSx,
  fontSize: '12px',
  mt: 1,
  textAlign: 'left',
};

export const mapUnavailableListSx = {
  ...mapUnavailableTextSx,
  fontSize: '12px',
  textAlign: 'left',
  m: 0,
  mt: 1,
  pl: 2.25,
  '& li + li': { mt: 0.5 },
};

export const mapUnavailableToggleSx = {
  fontFamily: font,
  fontSize: '12px',
  textTransform: 'none',
  color: colors.primary,
  minWidth: 0,
  px: 1,
  py: 0.25,
  '&:hover': { bgcolor: `${colors.primary}14` },
};

export const mapUnavailableLinkSx = {
  display: 'inline-flex',
  alignItems: 'center',
  gap: 0.5,
  fontFamily: font,
  fontSize: '13px',
  fontWeight: typography.fontWeight.medium,
  color: colors.primary,
};

/** Aviso chico arriba de la lista / ficha en los share. */
export const mapUnavailableInlineSx = {
  px: 1.5,
  py: 1,
  borderRadius: spacing.borderRadius.md,
  border: `1px solid ${colors.border}`,
  bgcolor: colors.backgroundSurface,
  boxSizing: 'border-box',
};
